import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { formatToEuro } from "@ster/ster-toolkit";
import { Rule } from "antd/lib/form";
import { useCallback } from "react";

export type BonusValidationConfiguration = {
  minimum: number;
  maximum: number;
};

const useBonusValidationGenerator = () => {
  const i18n = useLingui();

  const createWithConfig = useCallback(
    ({ minimum, maximum }: BonusValidationConfiguration) => {
      const rules: Rule[] = [
        {
          validator: async (_: unknown, value: number) => {
            if (value < minimum) {
              throw new Error(
                `${i18n._(t`Bonus moet groter dan of gelijk zijn aan`)} ${formatToEuro(minimum, false)}.`
              );
            }

            if (value > maximum) {
              throw new Error(
                `${i18n._(t`Bonus moet kleiner dan of gelijk zijn aan`)} ${formatToEuro(maximum, false)}.`
              );
            }
          },
        },
      ];
      return rules;
    },
    [i18n]
  );

  // Response
  return {
    createWithConfig,
  };
};

export default useBonusValidationGenerator;
